import Lottie from 'lottie-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface EmptyStateProps {
  animation?: string | object;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
    icon?: React.ReactNode;
  };
  className?: string;
  animationSize?: 'sm' | 'md' | 'lg';
}

export function EmptyState({
  animation,
  title,
  description,
  action,
  className,
  animationSize = 'md',
}: EmptyStateProps) {
  const sizeClasses = {
    sm: 'w-32 h-32',
    md: 'w-48 h-48',
    lg: 'w-64 h-64',
  };

  return (
    <div className={cn('flex flex-col items-center justify-center py-12 px-4', className)}>
      {animation && (
        <div className={cn('mb-6', sizeClasses[animationSize])}>
          {typeof animation === 'string' ? (
            <Lottie
              animationData={require(`../../public/animations/${animation}`)}
              loop
              autoplay
            />
          ) : (
            <Lottie animationData={animation} loop autoplay />
          )}
        </div>
      )}

      <div className="text-center space-y-3 max-w-md">
        <h3 className="text-xl font-semibold text-foreground">{title}</h3>
        {description && (
          <p className="text-muted-foreground text-sm leading-relaxed">
            {description}
          </p>
        )}
      </div>

      {action && (
        <Button onClick={action.onClick} className="mt-6" size="lg">
          {action.icon && <span className="mr-2">{action.icon}</span>}
          {action.label}
        </Button>
      )}
    </div>
  );
}
